import {
  BooleanInput,
  DeleteWithConfirmButton,
  Edit,
  ListButton,
  required,
  SaveButton,
  ShowButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { MODULE_NAMES } from "@/constants/modules";
import { ReferenceSelectInput } from "@/inputs/ReferenceSelectInput";

import { ipV4Vallidator } from "../utils/ipV4Vallidator";

import { RadiusVpnServerPrivacyTypeInput } from "./RadiusVpnServerPrivacyTypeInput";
import { RadiusVpnServerProtocolCsvInput } from "./RadiusVpnServerProtocolCsvInput";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ShowButton label="Cancel" icon={null} variant="outlined" size="medium" />
    <DeleteWithConfirmButton />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <ShowButton />
  </TopToolbar>
);

export const RadiusVpnServersEdit = () => {
  return (
    <Edit actions={<EditActions />} mutationMode="pessimistic">
      <SimpleForm toolbar={<EditToolbar />}>
        <TextInput source="createdAt" disabled />
        <TextInput source="updatedAt" disabled />
        <TextInput
          source="ip"
          helperText="Example: 127.0.0.1"
          validate={[required(), ipV4Vallidator]}
        />
        <ReferenceSelectInput
          module={MODULE_NAMES.DATA_CENTERS}
          source="dataCenter.@id"
          label="Data Center"
          optionText="name"
          optionValue="@id"
          validate={[required()]}
        />
        <ReferenceSelectInput
          module={MODULE_NAMES.COUNTRIES}
          source="country.@id"
          label="Country"
          optionText="name"
          optionValue="@id"
          validate={[required()]}
        />
        <ReferenceSelectInput
          module={MODULE_NAMES.CITIES}
          source="city.@id"
          label="City"
          optionText="name"
          optionValue="@id"
          validate={[required()]}
        />
        <RadiusVpnServerPrivacyTypeInput source="privacyType" />
        <ReferenceSelectInput
          module={MODULE_NAMES.ACCESS_LEVELS}
          source="accessLevel.@id"
          optionText="title"
          optionValue="@id"
          validate={[required()]}
        />
        <BooleanInput source="active" defaultChecked={false} />

        <TextInput
          source="host"
          helperText="Example: https://hostname.com"
          defaultValue="https://"
          validate={[required()]}
        />
        <RadiusVpnServerProtocolCsvInput
          source="protocolsCsv"
          validate={[required()]}
        />
        <BooleanInput source="alive" defaultChecked={false} disabled />
        <BooleanInput source="autoCreated" defaultChecked={false} disabled />
      </SimpleForm>
    </Edit>
  );
};
